import Marquee from "react-fast-marquee";
import { useLang } from "@/i18n/LanguageContext";

export const EditorialMarquee = () => {
  const { t } = useLang();
  return (
    <section className="py-16 md:py-24 bg-white border-y border-vw-silver overflow-hidden">
      <Marquee speed={40} gradient={false} autoFill direction="left">
        {t.marquee.map((w, i) => (
          <span key={i} className="flex items-center">
            <span className="font-serif text-[3.5rem] md:text-[6rem] leading-none text-vw-green/10 px-8">
              {w}
            </span>
            <span className="text-vw-green/20 text-4xl">·</span>
          </span>
        ))}
      </Marquee>
    </section>
  );
};
